import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';

export const BenefitInfo = styled.div`
  padding: 30px 48px;

  ${maxMediaQueries.tablet`
    max-width: ${grid(5) + 96}px;
    padding: 0 48px;
    margin: 0 auto;
  `};

  ${maxMediaQueries.phone`
    padding: 0 24px;
  `};
`;
